module.exports = __webpack_public_path__ + "img/c5.8a1acb9c.gif";